import * as t from 'io-ts';

export const participantSource = {
  registry: 'registry',
  registry_jaeb: 'registry_jaeb',
  jaeb: 'jaeb',
} as const;
export const participantSourceSchema = t.keyof(participantSource);
export type ParticipantSourceType = t.TypeOf<typeof participantSourceSchema>;
